module.exports = __webpack_public_path__ + "img/bell-on.fc9267d0.svg";